import React from 'react';
import Block from './Block';

import { Typography, Box, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import PrimeButton from "../PrimeButton";
import {ReactComponent as PlayIcon} from "../../Icons/Play-fill.svg";
import {ReactComponent as DownloadIcon} from "../../Icons/Download.svg";

const useStyles = makeStyles(theme => ({
    block: {
        width: '100%',
        display: 'grid',
        "& .MuiButton-endIcon": {
            transitionDuration: theme.transitions.duration.standard,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            transitionProperty: "color",
            color: theme.palette.secondary.muted,
        },
        "&:hover .MuiButton-endIcon": {
            color: theme.palette.primary.main,
        },
        borderRadius: 0,
    },
    heading: {
        margin: 0,
        paddingBottom: theme.spacing(3)
    },
    text: {
        color: theme.palette.secondary.muted2,
        margin: 0,
        marginLeft: ".5rem",
        //marginTop: ".75rem",
        textTransform: "uppercase",
    },
    textContainer: {
        display: 'flex',
        alignItems: "center",
    },
    downloadButton: {
        display: "flex",
        border: '1px solid '+theme.palette.secondary.light,
        padding: theme.spacing(.75),
        borderRadius: 0,
        width: 32,
        height: 32,
        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
        '& svg': {
            width: '1rem',
            height: '1rem',
        },
        '&:hover svg path': {
            fill: theme.palette.primary.main,
        },
    }
}));

export default function DownloadContentBlock({ heading, loading=false, allowDownload = false, fileSize = null, fileType = null, minHeight = "5.5em", onDownload = ()=>{}, onPlay = ()=>{}, ...props }) {
    const classes = useStyles();

    const text = [fileSize, fileType]
        .filter(x => x)
        .join(" | ");

    return (
        <Block className={classes.block} style={{minHeight}} padding="1rem 1rem" {...props}>
            <Typography variant="h6" className={classes.heading}>{heading}</Typography>
            <Box display="flex" className={classes.textContainer} justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    {allowDownload && (
                        <IconButton className={classes.downloadButton} onClick={onDownload} size="large">
                            <DownloadIcon />
                        </IconButton>
                    )}

                    {text ?
                        <Typography variant="caption" component="div" className={classes.text}>{text}</Typography>
                        : ''
                    }
                </Box>
                <PrimeButton disabled={loading} icon={<PlayIcon />} text="Play" variant="contained" styles={{'float':'right'}} onClick={onPlay} />
            </Box>
        </Block>
    );
}